import React from 'react';
import MarketingMyPathBoardPreview from './MarketingMyPathBoardPreview';
import MarketingLessonPreview from './MarketingLessonPreview';
import { demoFuelPassionModuleDetail } from './marketingDemoData';
import './MarketingAssets.css';

/** My Path board (left) + open Fuel your Passion lesson (right). */
const MarketingMyPathCompositePreview = () => (
    <div className="marketing-my-path-composite">
        <div className="marketing-my-path-composite__board">
            <MarketingMyPathBoardPreview />
        </div>
        <div className="marketing-my-path-composite__lesson">
            <MarketingLessonPreview
                embedded
                showHeader={false}
                compact
                moduleDetail={demoFuelPassionModuleDetail}
            />
        </div>
    </div>
);

export default MarketingMyPathCompositePreview;
